import { useErrorInlineNotificationAPI } from '@/components/ErrorInlineNotification/ErrorInlineNotification';
import {
  TransactionItemDetailOptionStatus,
  useDeleteTransactionItemDetailOption,
} from '@/context/services/transaction_items/Detail/TransactionItemDetail.service';
import { useErrorTrackingSystem } from '@/hooks/useErrorTrackingSystem';
import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

export const useDeleteTransactionDetailOption = () => {
  const { transaction_item_id } = useParams();
  const { mutateAsync, isLoading } = useDeleteTransactionItemDetailOption(
    transaction_item_id ?? ''
  );
  const { send } = useErrorTrackingSystem();
  const { t } = useTranslation();
  const notify = useToastAPI();
  const setErrorNotification = useErrorInlineNotificationAPI();

  const onDelete = useCallback(
    async (id: string, label: string) => {
      try {
        const resp = await mutateAsync(id);
        if (resp.status === TransactionItemDetailOptionStatus.SUCCESS) {
          notify.success({
            title: t('transaction_items.detail.options.delete.success', {
              label: label,
            }),
            duration: 3,
          });
        } else if (resp.status === TransactionItemDetailOptionStatus.AUTH) {
          location.href = resp.redirectPath;
        } else if (
          resp.status === TransactionItemDetailOptionStatus.PROXY_LOGIN_ERROR
        ) {
          setErrorNotification(new Error(resp.errors.messages?.join('\n')));
        } else {
          notify.error({
            title: t('transaction_items.detail.options.delete.error', {
              label: label,
            }),
            duration: 3,
          });
        }
      } catch (error) {
        if (error instanceof Error && error?.name === 'AxiosError') {
          send(error.message);
        } else {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          send(error as Error);
        }
        notify.error({
          title: t('transaction_items.detail.options.delete.error', {
            label: label,
          }),
          duration: 3,
        });
      }
    },
    [mutateAsync, t, send, notify, setErrorNotification]
  );

  return { onDelete, isLoading };
};
